import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=7bc662ba&scoped=true&"
var script = {}
import style0 from "./Join.vue?vue&type=style&index=0&id=7bc662ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc662ba",
  null
  
)

export default component.exports